import React from "react";

interface NotificationProps {
  message: string;
}

const Notification: React.FC<NotificationProps> = ({ message }) => {
  return (
    <div className="fixed bottom-4 left-4 bg-slateGray text-white px-4 py-2 rounded shadow-lg z-50">
      {message}
    </div>
  );
};

export default Notification;
